// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  width: 14px;
  height: 100%;
}
:host > span, :host announcekit {
  width: 14px;
  position: absolute;
  right: 0;
}
:host announcekit {
  top: 50%;
  transform: translateY(-50%);
}
:host span {
  top: 0;
  display: inline-block;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/content/layout/components/general/header/components/header-bottom/menu-announcekit/menu-announcekit.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;AACJ;AAEE;EACE,QAAA;EACA,2BAAA;AAAJ;AAGE;EACE,MAAA;EACA,qBAAA;EACA,YAAA;AADJ","sourcesContent":[":host {\n  position: relative;\n  width: 14px;\n  height: 100%;\n\n  > span,announcekit {\n    width: 14px;\n    position: absolute;\n    right: 0;\n  }\n\n  announcekit {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  span {\n    top: 0;\n    display: inline-block;\n    height: 100%\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
